// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadcrumbItemButton_container__enCyx"};